<script setup lang="ts">
import { computed, type Ref } from 'vue'

import type { FilterCriteriaAsyncFilter, LoadRevenueTiersForCriteria, RevenueTierCriterion } from '../../../../types'
import CriteriaAsyncEntitySelect from '../CriteriaAsyncEntitySelect.vue'
import CriteriaFieldCell from '../CriteriaFieldCell.vue'
import { useCriterionField } from '../useCriterionField'

const props = withDefaults(
  defineProps<{
    row: RevenueTierCriterion
    /** Absent where the host does not offer revenue tier criteria at all. */
    loadRevenueTiers?: LoadRevenueTiersForCriteria
    isDisabled?: boolean
  }>(),
  { loadRevenueTiers: undefined, isDisabled: false },
)
const emits = defineEmits<(e: 'update:row', row: RevenueTierCriterion) => void>()

const revenueTier = useCriterionField(props, emits, 'revenueTier')

const loadOptions = (filterRef: Ref<FilterCriteriaAsyncFilter>) => {
  const { data, isLoading, error } = props.loadRevenueTiers!(filterRef)
  return {
    data: computed(() => data.value.map((revenueTierOption) => ({ id: revenueTierOption.id, label: revenueTierOption.name }))),
    isLoading,
    error,
  }
}
</script>

<template>
  <CriteriaFieldCell v-if="loadRevenueTiers">
    <CriteriaAsyncEntitySelect
      v-model="revenueTier"
      :is-disabled="isDisabled"
      :load-options="loadOptions"
      placeholder="Default"
      size="large"
    />
  </CriteriaFieldCell>
</template>
